module.exports = __webpack_public_path__ + "img/corona.0b61c5f8.png";